import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const AssetsAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.ASSET}
      title="Assets Automation"
      breadcrumb="Assets"
      module="assets"
    />
  );
};

export default AssetsAutomation;
